import CashProcessingLineItemBase from './base/CashProcessingLineItemBase';

/**
 * @class CashProcessingLineItem
 * @extends CashProcessingLineItemBase
 */
class CashProcessingLineItem extends CashProcessingLineItemBase {

}

export default CashProcessingLineItem;
